import React from "react";

import { SignUpFormContainer } from "../Form/SignUpForm";
import Modal from "../Modal";
import { useModal } from "../../context/ModalContext";

const SignUpModal: React.FC = () => {
  const { isSignupOpen, closeSignupModal, openLoginModal } = useModal();
  const handleSubmit = (
    username: string,
    email: string,
    password: string,
    firstname: string,
    lastname: string,
    othername: string,
    phonenumber: string,
    language: string,
  ) => {
    console.log("Sign up:", {
      username,
      email,
      password,
      firstname,
      lastname,
      othername,
      phonenumber,
      language,
    });
  };

  return (
    <Modal
      isOpen={isSignupOpen}
      onClose={closeSignupModal}
      className="w-full max-w-md p-2" // Added padding
    >
      <div className="overflow-y-auto max-h-[90vh]">
        <SignUpFormContainer
          onSignIn={() => {
            closeSignupModal();
            openLoginModal();
          }}
          onSubmit={handleSubmit}
          closeSignUpModal={closeSignupModal}
        />
      </div>
    </Modal>
  );
};

export default SignUpModal;
